/* ==========================================================================
   PDP Frequently Bought Together — multi-item add to cart.
   Adds every checked item in one request via /cart/add.js (items: [...]).
   ========================================================================== */
(function () {
  'use strict';

  function initFbt(root) {
    var addBundleBtn = root.querySelector('.js-pdp-fbt-add-bundle');
    if (!addBundleBtn) return;

    addBundleBtn.addEventListener('click', function () {
      var checkboxes = root.querySelectorAll('.js-pdp-fbt-checkbox:checked');
      if (!checkboxes.length) return;

      var items = Array.prototype.map.call(checkboxes, function (cb) {
        return { id: parseInt(cb.getAttribute('data-variant-id'), 10), quantity: 1 };
      }).filter(function (item) { return !isNaN(item.id); });

      if (!items.length) return;

      addBundleBtn.disabled = true;
      var originalText = addBundleBtn.textContent;
      addBundleBtn.textContent = '...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw err; });
          return res.json();
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('pdp-fbt:added-to-cart'));
          addBundleBtn.textContent = originalText;
          addBundleBtn.disabled = false;
        })
        .catch(function (err) {
          addBundleBtn.textContent = originalText;
          addBundleBtn.disabled = false;
          var message = (err && err.description) || 'Could not add the bundle to your cart.';
          alert(message);
        });
    });

    // Recompute the running total when a companion item is unchecked.
    root.querySelectorAll('.js-pdp-fbt-checkbox').forEach(function (cb) {
      cb.addEventListener('change', function () {
        var checked = root.querySelectorAll('.js-pdp-fbt-checkbox:checked');
        var total = 0;
        checked.forEach(function (c) { total += parseInt(c.getAttribute('data-price'), 10) || 0; });

        var discountPct = parseFloat(addBundleBtn.getAttribute('data-discount-percent')) || 0;
        var bundlePrice = total - (total * discountPct / 100);
        var savings = total - bundlePrice;

        var totalEl = root.querySelector('.js-pdp-fbt-total');
        var bundleEl = root.querySelector('.js-pdp-fbt-bundle-total');
        var savingsEl = root.querySelector('.js-pdp-fbt-savings');
        if (totalEl && window.Shopify) totalEl.textContent = Shopify.formatMoney(total, window.money_format);
        if (bundleEl && window.Shopify) bundleEl.textContent = Shopify.formatMoney(bundlePrice, window.money_format);
        if (savingsEl && window.Shopify) savingsEl.textContent = Shopify.formatMoney(savings, window.money_format);
      });
    });
  }

  function init() {
    document.querySelectorAll('.pdp-fbt').forEach(initFbt);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
